import { Button, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { HiDotsVertical } from "react-icons/hi";

export default function TableMenu({ menuItems, isDisabled }) {
  return (
    <Menu>
      {({ isOpen }) => (
        <>
          <MenuButton
            isActive={isOpen}
            as={Button}
            isDisabled={isDisabled}
            bg="none"
            minH="unset"
            width="32px"
            minWidth="unset"
            maxW="32px"
            height="32px"
            maxH="32px"
            p="0px 8px"
            borderRadius={0}
            _active={{
              bg: "gray.100",
            }}
            _disabled={{
              opacity: 0.35,
              cursor: "not-allowed",
              pointerEvents: "none",
            }}
          >
            <HiDotsVertical />
          </MenuButton>
          <MenuList width="150px" maxW="150px" p='12px' borderRadius="12px">
            {menuItems?.map((menuItem, index) => (
              <MenuItem
                key={index}
                onClick={menuItem?.handler}
                color="#515D63"
                fontSize="sm"
                fontWeight={500}
                lineHeight="18.48px"
                p="8px 16px"
              >
                {menuItem?.label}
              </MenuItem>
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  );
}
